export default function renderRoot(chart, { classes }) {
  return chart
    .classed('PackedCircleChart--root', true)
    .classed(classes.root.join(' '), true)
    .attr('x', 30)
    .html('');
}
